import { useEffect, useState } from "react";
import { useMsal } from "@azure/msal-react";
import { loginRequest } from "../authConfig";

export function useProfilePhoto() {
  const { instance, accounts } = useMsal();
  const [photo, setPhoto] = useState(null);

  useEffect(() => {
    if (accounts.length === 0) return;

    const fetchPhoto = async () => {
      try {
        const response = await instance.acquireTokenSilent({
          ...loginRequest,
          account: accounts[0],
        });

        const res = await fetch(
          "https://graph.microsoft.com/v1.0/me/photo/$value",
          {
            headers: {
              Authorization: `Bearer ${response.accessToken}`,
            },
          }
        );

        if (res.ok) {
          const blob = await res.blob();
          setPhoto(URL.createObjectURL(blob));
        }
      } catch (err) {
        console.error("Error fetching profile photo:", err);
      }
    };

    fetchPhoto();
  }, [instance, accounts]);

  return photo;
}
